(function(){
  if (window.__vwProtectionModule) return;
  window.__vwProtectionModule = true;

  var VARIANT_ID = 56361615556983;
  var ATTR_KEY   = 'vwp_protection';   // server-side intent: 'on' | 'off' | absent(=default on)

  /* ============ low-level cart calls ============ */
  function getCart(){
    return fetch('/cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); });
  }

  // Absolute-quantity write, idempotent: running it twice yields the same cart,
  // so a double click / two tabs can never stack qty=2 (the money bug).
  // NOTE: /cart/update.js can only CHANGE an existing line (422 otherwise),
  // so we add with /cart/add.js first and then clamp with update.js.
  function writeQty(qty){
    var updates = {};
    updates[String(VARIANT_ID)] = qty;
    return fetch('/cart/update.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({updates: updates})
    }).then(function(r){
      if (!r.ok) return r.text().then(function(t){ throw new Error('update failed: '+t); });
      return r.json();
    });
  }

  function addOne(){
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id: VARIANT_ID, quantity: 1})
    }).then(function(r){
      if (!r.ok) return r.text().then(function(t){ throw new Error('add failed: '+t); });
      return r.json();
    });
  }

  // Target state in one call. Always ends at exactly `qty`, whatever the start was.
  function setProtectionQty(qty){
    return getCart().then(function(cart){
      var have = protQty(cart);
      if (have === qty) return cart;
      if (qty === 0) return writeQty(0);
      if (have === 0) {
        // not in the cart yet -> add, then clamp in case a parallel click also added
        return addOne().then(function(){ return writeQty(qty); })
                       .catch(function(){ return writeQty(qty); });
      }
      return writeQty(qty);   // present but wrong quantity (e.g. the qty=2 bug) -> clamp
    });
  }

  function setIntent(choice){
    var attrs = {}; attrs[ATTR_KEY] = choice;
    return fetch('/cart/update.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({attributes: attrs})
    }).then(function(r){ return r.json(); });
  }

  // Intent is the ONLY source of truth for the UI. Absent => default ON.
  function intentOn(cart){
    var a = cart && cart.attributes ? cart.attributes[ATTR_KEY] : null;
    return a !== 'off';
  }

  function protQty(cart){
    return (cart.items||[]).reduce(function(n,i){ return i.variant_id===VARIANT_ID ? n+i.quantity : n; }, 0);
  }

  function realItemCount(cart){
    return (cart.items||[]).reduce(function(n,i){ return i.variant_id===VARIANT_ID ? n : n+i.quantity; }, 0);
  }

  /* ============ reconcile: make cart match intent ============ */
  var inflight = null;

  function reconcile(){
    if (inflight) return inflight;                       // coalesce concurrent calls
    inflight = getCart().then(function(cart){
      var want = intentOn(cart) ? 1 : 0;
      if (realItemCount(cart) === 0) want = 0;           // never protect an empty cart
      var have = protQty(cart);
      if (have === want) return cart;                    // already correct (also fixes qty>1)
      return setProtectionQty(want);
    }).then(function(cart){
      inflight = null;
      return cart;
    }).catch(function(e){
      inflight = null;
      console.error('vwp reconcile failed', e);
      return getCart();
    });
    return inflight;
  }

  /* ============ view ============ */
  function hideProtectionLineItems(){
    // Robust: match by variant id (works with localized product titles),
    // with href/alt as a fallback for themes that don't expose the id.
    var rows = document.querySelectorAll('line-item.line-item, tr.line-item, .line-item');
    rows.forEach(function(li){
      if (!li.classList || !li.classList.contains('line-item')) return;
      if (li.tagName.toLowerCase() === 'line-item-table') return;
      var hit = false;
      if (li.querySelector('[data-vwp-line]')) hit = true;
      if (!hit && li.getAttribute && li.getAttribute('data-vwp-line') !== null) hit = true;
      if (!hit && li.querySelector('a[href*="variant=' + VARIANT_ID + '"]')) hit = true;
      if (!hit && li.querySelector('a[href*="shipping-protection"]')) hit = true;
      if (!hit && li.querySelector('img[alt*="Shipping Protection" i], img[alt*="shipping-protection" i]')) hit = true;
      if (!hit) {
        var inp = li.querySelector('[name="updates[]"], [data-line-id], input[name*="id"]');
        if (inp) {
          var v = inp.value || inp.getAttribute('data-line-id') || '';
          if (String(v).indexOf(String(VARIANT_ID)) !== -1) hit = true;
        }
      }
      if (hit) li.style.display = 'none';
    });
  }

  // Render money exactly like the shop does. The Liquid puts the real
  // money_format on the element (data-money-format), e.g. "{{amount_with_comma_separator}} kr"
  // so DKK/SEK/PLN/RON/CZK and symbol-after locales all come out right.
  function groupNumber(intPart, thousands){
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  }

  function renderAmount(cents, token){
    var neg = cents < 0;
    var v = Math.abs(cents);
    var whole, out;
    if (token === 'amount_no_decimals') {
      whole = String(Math.round(v/100));
      out = groupNumber(whole, ',');
    } else if (token === 'amount_no_decimals_with_comma_separator') {
      whole = String(Math.round(v/100));
      out = groupNumber(whole, '.');
    } else if (token === 'amount_with_comma_separator') {
      var s1 = (v/100).toFixed(2).split('.');
      out = groupNumber(s1[0], '.') + ',' + s1[1];
    } else if (token === 'amount_with_apostrophe_separator') {
      var s3 = (v/100).toFixed(2).split('.');
      out = groupNumber(s3[0], "'") + '.' + s3[1];
    } else if (token === 'amount_with_period_separator') {
      var s4 = (v/100).toFixed(2).split('.');
      out = groupNumber(s4[0], ' ') + '.' + s4[1];
    } else if (token === 'amount_with_space_separator') {
      // Swedish style: space as thousands separator, comma as decimal (469,00 kr)
      var s5 = (v/100).toFixed(2).split('.');
      out = groupNumber(s5[0], '\u00a0') + ',' + s5[1];
    } else if (token === 'amount_no_decimals_with_space_separator') {
      out = groupNumber(String(Math.round(v/100)), '\u00a0');
    } else { // 'amount'
      var s2 = (v/100).toFixed(2).split('.');
      out = groupNumber(s2[0], ',') + '.' + s2[1];
    }
    return (neg ? '-' : '') + out;
  }

  function formatMoney(cents, currency, fmt){
    if (fmt && fmt.indexOf('{{') !== -1) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, token){
        return renderAmount(cents, token);
      }).trim();
    }
    // fallback if no format was supplied by Liquid
    var amount = (cents/100).toFixed(2);
    var symbols = {USD:'$', EUR:'\u20ac', GBP:'\u00a3'};
    var sym = symbols[currency];
    return sym ? (sym + amount) : (amount + ' ' + currency);
  }

  // Prijs van de protection in centen; onthouden zodat het totaal ook klopt
  // wanneer het product NIET in de cart zit (vinkje uit).
  var protPriceCents = null;

  function learnProtPrice(cart){
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.variant_id === VARIANT_ID && it.quantity > 0) {
          protPriceCents = Math.round((it.final_line_price != null ? it.final_line_price : it.line_price) / it.quantity);
          return protPriceCents;
        }
      }
    }
    if (protPriceCents === null) {
      var el = document.querySelector('[data-vwp-price], [class*="asc-shipping-protection-price"]');
      if (el) {
        var txt = (el.textContent || '').replace(/[^0-9.,]/g, '');
        if (/,\d{2}$/.test(txt))       txt = txt.replace(/\./g, '').replace(',', '.');
        else if (/\.\d{2}$/.test(txt)) txt = txt.replace(/,/g, '');
        var n = parseFloat(txt);
        if (!isNaN(n) && n > 0) protPriceCents = Math.round(n * 100);
      }
    }
    return protPriceCents;
  }

  // isOn bepaalt of de protection meetelt, zodat het bedrag DIRECT beweegt
  // en niet pas na de server-respons.
  function updateVisibleTotal(cartOrOn){
    var isOn;
    if (typeof cartOrOn === 'boolean') {
      isOn = cartOrOn;
    } else if (cartOrOn && cartOrOn.items) {
      learnProtPrice(cartOrOn);
      isOn = protQty(cartOrOn) > 0;
    } else {
      isOn = (lastIntent === true);
    }
    if (protPriceCents === null) learnProtPrice(null);
    var add = (isOn && protPriceCents) ? protPriceCents : 0;
    document.querySelectorAll('#mc-total-value, [data-vwp-total]').forEach(function(el){
      var base = parseInt(el.getAttribute('data-base-cents'), 10);
      if (isNaN(base)) return;
      var cur = el.getAttribute('data-currency') || (cartOrOn && cartOrOn.currency) || '';
      el.textContent = formatMoney(base + add, cur, el.getAttribute('data-money-format'));
    });
  }

  var VWP_SUBTITLES = {
    en: ['Your order is protected against loss, theft, or damage during shipping.', 'Protect your order against loss, theft, or damage during shipping.'],
    nl: ['Je bestelling is verzekerd tegen verlies, diefstal of schade tijdens verzending.', 'Verzeker je bestelling tegen verlies, diefstal of schade tijdens verzending.'],
    de: ['Ihre Bestellung ist gegen Verlust, Diebstahl oder Besch\u00e4digung w\u00e4hrend des Versands gesch\u00fctzt.', 'Sch\u00fctzen Sie Ihre Bestellung gegen Verlust, Diebstahl oder Besch\u00e4digung w\u00e4hrend des Versands.'],
    da: ['Din ordre er beskyttet mod tab, tyveri eller skade under forsendelsen.', 'Beskyt din ordre mod tab, tyveri eller skade under forsendelsen.'],
    sv: ['Din best\u00e4llning \u00e4r skyddad mot f\u00f6rlust, st\u00f6ld eller skada under frakten.', 'Skydda din best\u00e4llning mot f\u00f6rlust, st\u00f6ld eller skada under frakten.'],
    it: ['Il tuo ordine \u00e8 protetto contro smarrimento, furto o danni durante la spedizione.', 'Proteggi il tuo ordine contro smarrimento, furto o danni durante la spedizione.'],
    es: ['Tu pedido est\u00e1 protegido contra p\u00e9rdida, robo o da\u00f1os durante el env\u00edo.', 'Protege tu pedido contra p\u00e9rdida, robo o da\u00f1os durante el env\u00edo.'],
    fr: ["Votre commande est prot\u00e9g\u00e9e contre la perte, le vol ou les dommages pendant l'exp\u00e9dition.", "Prot\u00e9gez votre commande contre la perte, le vol ou les dommages pendant l'exp\u00e9dition."],
    pl: ['Twoje zam\u00f3wienie jest chronione przed zgubieniem, kradzie\u017c\u0105 lub uszkodzeniem podczas wysy\u0142ki.', 'Chro\u0144 swoje zam\u00f3wienie przed zgubieniem, kradzie\u017c\u0105 lub uszkodzeniem podczas wysy\u0142ki.'],
    cs: ['Va\u0161e objedn\u00e1vka je chr\u00e1n\u011bna proti ztr\u00e1t\u011b, kr\u00e1de\u017ei nebo po\u0161kozen\u00ed b\u011bhem p\u0159epravy.', 'Chra\u0148te svou objedn\u00e1vku proti ztr\u00e1t\u011b, kr\u00e1de\u017ei nebo po\u0161kozen\u00ed b\u011bhem p\u0159epravy.'],
    ro: ['Comanda dvs. este protejat\u0103 \u00eempotriva pierderii, furtului sau deterior\u0103rii \u00een timpul livr\u0103rii.', 'Proteja\u021bi-v\u0103 comanda \u00eempotriva pierderii, furtului sau deterior\u0103rii \u00een timpul livr\u0103rii.'],
    fi: ['Tilauksesi on suojattu katoamiselta, varkaudelta tai vaurioilta kuljetuksen aikana.', 'Suojaa tilauksesi katoamiselta, varkaudelta tai vaurioilta kuljetuksen aikana.'],
    sk: ['Va\u0161a objedn\u00e1vka je chr\u00e1nen\u00e1 proti strate, kr\u00e1de\u017ei alebo po\u0161kodeniu po\u010das prepravy.', 'Chr\u00e1\u0148te svoju objedn\u00e1vku proti strate, kr\u00e1de\u017ei alebo po\u0161kodeniu po\u010das prepravy.'],
    hu: ['Rendel\u00e9s\u00e9t v\u00e9dj\u00fck az elveszt\u00e9ssel, lop\u00e1ssal vagy sz\u00e1ll\u00edt\u00e1s k\u00f6zbeni s\u00e9r\u00fcl\u00e9ssel szemben.', 'V\u00e9dje meg rendel\u00e9s\u00e9t az elveszt\u00e9st\u0151l, lop\u00e1st\u00f3l vagy sz\u00e1ll\u00edt\u00e1s k\u00f6zbeni s\u00e9r\u00fcl\u00e9st\u0151l.'],
    lt: ['J\u016bs\u0173 u\u017esakymas apsaugotas nuo praradimo, vagyst\u0117s ar sugadinimo pristatymo metu.', 'Apsaugokite savo u\u017esakym\u0105 nuo praradimo, vagyst\u0117s ar sugadinimo pristatymo metu.'],
    lv: ['J\u016bsu pas\u016bt\u012bjums ir aizsarg\u0101ts pret nozaud\u0113\u0161anu, z\u0101dzibu vai boj\u0101jumiem pieg\u0101des laik\u0101.', 'Aizsarg\u0101jiet savu pas\u016bt\u012bjumu pret nozaud\u0113\u0161anu, z\u0101dzibu vai boj\u0101jumiem pieg\u0101des laik\u0101.']
  };

  function vwpDetectLang(){
    var htmlLang = (document.documentElement.lang || '').toLowerCase();
    var path = window.location.pathname.toLowerCase();
    var candidates = [htmlLang.split('-')[0]];
    var m = path.match(/^\/([a-z]{2})(-[a-z]{2})?\//);
    if (m) candidates.unshift(m[1]);
    for (var i=0;i<candidates.length;i++){ if (VWP_SUBTITLES[candidates[i]]) return candidates[i]; }
    return 'en';
  }

  function paintAll(isOn){
    document.querySelectorAll('[data-vwp-root]').forEach(function(root){
      var toggle   = root.querySelector('[data-vwp-toggle]');
      var subtitle = root.querySelector('[data-vwp-subtitle]');
      var img      = root.querySelector('[data-vwp-image]');
      if (toggle) {
        toggle.setAttribute('aria-checked', isOn ? 'true' : 'false');
        toggle.setAttribute('data-vwp-intent', isOn ? 'on' : 'off');
      }
      if (subtitle) {
        var texts = VWP_SUBTITLES[vwpDetectLang()] || VWP_SUBTITLES.en;
        subtitle.textContent = isOn ? texts[0] : texts[1];
      }
      if (img) img.style.filter = isOn ? 'grayscale(0)' : 'grayscale(1)';
    });
    updateVisibleTotal(isOn);   // bedrag beweegt mee met het vinkje
  }

  function setBusyUI(on){
    document.querySelectorAll('[data-vwp-toggle]').forEach(function(t){
      t.style.pointerEvents = on ? 'none' : '';
      t.style.opacity       = on ? '0.6' : '';
    });
  }

  /* ============ intent cache: survives theme re-renders ============ */
  // The theme replaces drawer HTML ~600-750ms after a cart change, restoring
  // server markup. We keep the last known intent and re-assert it after that.
  var lastIntent = null;

  function repaintFromServer(){
    return getCart().then(function(cart){
      var on = intentOn(cart);
      lastIntent = on;
      paintAll(on);
      hideProtectionLineItems();
      updateVisibleTotal(cart);
      return cart;
    }).catch(function(){});
  }

  function reassertIntent(){
    if (lastIntent === null) return repaintFromServer();
    paintAll(lastIntent);
    hideProtectionLineItems();
    updateVisibleTotal(lastIntent);   // thema zette het server-totaal terug
    return Promise.resolve();
  }

  /* ============ toggle ============ */
  var busy = false;

  function handleToggle(){
    if (busy) return Promise.resolve();
    busy = true;
    setBusyUI(true);

    // Read intent from our own state, NEVER from the DOM (server markup lies).
    var willBeOn = !(lastIntent === null ? false : lastIntent);

    lastIntent = willBeOn;
    paintAll(willBeOn);

    return setIntent(willBeOn ? 'on' : 'off')
      .then(function(){ return setProtectionQty(willBeOn ? 1 : 0); })
      .then(function(cart){
        lastIntent = intentOn(cart);
        paintAll(lastIntent);
        hideProtectionLineItems();
        updateVisibleTotal(cart);
      })
      .catch(function(e){
        console.error('vwp toggle failed', e);
        return repaintFromServer();
      })
      .then(function(){
        busy = false;
        setBusyUI(false);
        // The theme re-renders shortly after a cart mutation; re-assert after it lands.
        setTimeout(reassertIntent, 400);
        setTimeout(reassertIntent, 900);
        setTimeout(reassertIntent, 1400);
      });
  }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest && e.target.closest('[data-vwp-toggle]');
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation();
    handleToggle();
  }, true);

  /* ============ checkout safety net ============ */
  // Non-blocking: keyed on intent already being persisted server-side, so even
  // accelerated checkout (Shop Pay / PayPal) carries the correct cart.
  var CHECKOUT_SEL = '.checkout-button, [class*="checkout-button"], button[name="checkout"], [href="/checkout"], [href*="/checkout"], [onclick*="checkout"], form[action*="/cart"] [type="submit"]';

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (!btn) return;
    if (btn.__vwpReady) { btn.__vwpReady = false; return; }
    e.preventDefault();
    e.stopPropagation();
    reconcile().catch(function(){}).then(function(){
      btn.__vwpReady = true;
      btn.click();
    });
  }, true);

  // Covers accelerated checkout buttons that bypass our click handler.
  window.addEventListener('pagehide', function(){
    try {
      if (lastIntent === null) return;
      var updates = {}; updates[String(VARIANT_ID)] = lastIntent ? 1 : 0;
      var blob = new Blob([JSON.stringify({updates: updates})], {type:'application/json'});
      navigator.sendBeacon('/cart/update.js', blob);
    } catch(e){}
  });

  /* ============ boot ============ */
  function boot(){
    hideProtectionLineItems();
    reconcile().then(function(cart){
      lastIntent = intentOn(cart);
      paintAll(lastIntent);
      hideProtectionLineItems();
      updateVisibleTotal(cart);
    });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);

  function watchCartContainers(){
    var containers = document.querySelectorAll('#mini-cart-form, .line-item-table, cart-drawer, [id^="shopify-section-mini-cart"], [id^="shopify-section-main-cart"]');
    if (!containers.length) return;
    var t = null;
    var mo = new MutationObserver(function(){
      hideProtectionLineItems();
      clearTimeout(t);
      t = setTimeout(function(){ if (!busy) reassertIntent(); }, 120);
    });
    containers.forEach(function(c){ mo.observe(c, {childList:true, subtree:true}); });
  }
  if (document.readyState !== 'loading') watchCartContainers(); else document.addEventListener('DOMContentLoaded', watchCartContainers);

  ['cart:refresh','cart:updated','cart:change','on:cart-update'].forEach(function(evt){
    document.addEventListener(evt, function(){
      if (busy) return;
      reassertIntent();
      setTimeout(reassertIntent, 800);   // after the theme's replacementDelay
      setTimeout(repaintFromServer, 1300);
    });
  });

  window.addEventListener('pageshow', function(){ if (!busy) repaintFromServer(); });
})();
